import { IconBaseType } from "@/v2-components/core/icon/type";
import { cn } from "@/libs/utils";

export default function TooltipArrowIcon({ className }: IconBaseType) {
  return (
    <svg
      viewBox="0 0 20 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-[12px] w-[20px]", className)}
    >
      <path
        d="M8.46356 10.1563C9.26315 11.1158 10.7369 11.1158 11.5364 10.1563L20 3.49691e-06L2.09815e-06 0L8.46356 10.1563Z"
        fill="currentColor"
      />
    </svg>
  );
}
